import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";

function Footer() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const t = translations[language];

  const handleNavClick = (e, hash) => {
    e.preventDefault();
    navigate("/");
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <footer className="footer">
      <div className="footer-container-links">
        <div className="footer-logo-container">{"i<am>"}</div>
        <div className="footer-column-container">
          <div className="footer-column-title">{t.footer.explore}</div>
          <div className="footer-column-links">
            <Link
              to="/#root"
              onClick={(e) => handleNavClick(e, "#root")}
              aria-label={t.footer.home}
            >
              {t.footer.home}
            </Link>
            <Link
              to="/#about-container"
              onClick={(e) => handleNavClick(e, "#about-container")}
              aria-label={t.sectionTitles.about}
            >
              {t.sectionTitles.about}
            </Link>
            <Link
              to="/#experience-container"
              onClick={(e) => handleNavClick(e, "#experience-container")}
              aria-label={t.sectionTitles.experience}
            >
              {t.sectionTitles.experience}
            </Link>
            <Link
              to="/#knowledge-container"
              onClick={(e) => handleNavClick(e, "#knowledge-container")}
              aria-label={t.sectionTitles.knowledge}
            >
              {t.sectionTitles.knowledge}
            </Link>
            <Link
              to="/#contact-container"
              onClick={(e) => handleNavClick(e, "#contact-container")}
              aria-label={t.sectionTitles.contact}
            >
              {t.sectionTitles.contact}
            </Link>
          </div>
        </div>
        <div className="footer-column-container">
          <div className="footer-column-title">{t.sectionTitles.contact}</div>
          <div className="footer-column-links">
            <a
              href="mailto:izamm1610@gmail.com"
              aria-label={t.footer.email}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.footer.email}
            </a>
            <a
              href="https://www.linkedin.com/in/iamizam/"
              aria-label={t.footer.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.footer.linkedin}
            </a>
            <a
              href="https://github.com/IamIzam"
              aria-label={t.footer.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.footer.github}
            </a>
          </div>
        </div>
        <div className="footer-column-container">
          <div className="footer-column-title">{t.footer.legal}</div>
          <div className="footer-column-links">
            <Link to="/privacy-policy" aria-label={t.footer.privacy}>
              {t.footer.privacy}
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-copyright">{t.footer.copyright}</div>
    </footer>
  );
}

export default Footer;
